import "vant/es/popover/style/less";
import _Popover from "vant/es/popover";
import "vant/es/swipe-cell/style/less";
import _SwipeCell from "vant/es/swipe-cell";
import "vant/es/skeleton/style/less";
import _Skeleton from "vant/es/skeleton";
import "vant/es/notice-bar/style/less";
import _NoticeBar from "vant/es/notice-bar";
import "vant/es/switch/style/less";
import _Switch from "vant/es/switch";
import "vant/es/datetime-picker/style/less";
import _DatetimePicker from "vant/es/datetime-picker";
import "vant/es/sticky/style/less";
import _Sticky from "vant/es/sticky";
import "vant/es/collapse-item/style/less";
import _CollapseItem from "vant/es/collapse-item";
import "vant/es/collapse/style/less";
import _Collapse from "vant/es/collapse";
import "vant/es/divider/style/less";
import _Divider from "vant/es/divider";
import "vant/es/cascader/style/less";
import _Cascader from "vant/es/cascader";
import "vant/es/progress/style/less";
import _Progress from "vant/es/progress";
import "vant/es/tag/style/less";
import _Tag from "vant/es/tag";
import "vant/es/slider/style/less";
import _Slider from "vant/es/slider";
import "vant/es/tabs/style/less";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style/less";
import _Tab from "vant/es/tab";
import "vant/es/overlay/style/less";
import _Overlay from "vant/es/overlay";
import "vant/es/password-input/style/less";
import _PasswordInput from "vant/es/password-input";
import "vant/es/number-keyboard/style/less";
import _NumberKeyboard from "vant/es/number-keyboard";
import "vant/es/count-down/style/less";
import _CountDown from "vant/es/count-down";
import "vant/es/stepper/style/less";
import _Stepper from "vant/es/stepper";
import "vant/es/image/style/less";
import _Image from "vant/es/image";
import "vant/es/radio/style/less";
import _Radio from "vant/es/radio";
import "vant/es/radio-group/style/less";
import _RadioGroup from "vant/es/radio-group";
import "vant/es/checkbox/style/less";
import _Checkbox from "vant/es/checkbox";
import "vant/es/checkbox-group/style/less";
import _CheckboxGroup from "vant/es/checkbox-group";
import "vant/es/pull-refresh/style/less";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/list/style/less";
import _List from "vant/es/list";
import "vant/es/dialog/style/less";
import _Dialog from "vant/es/dialog";
import "vant/es/image-preview/style/less";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/loading/style/less";
import _Loading from "vant/es/loading";
import "vant/es/step/style/less";
import _Step from "vant/es/step";
import "vant/es/steps/style/less";
import _Steps from "vant/es/steps";
import "vant/es/dropdown-menu/style/less";
import _DropdownMenu from "vant/es/dropdown-menu";
import "vant/es/dropdown-item/style/less";
import _DropdownItem from "vant/es/dropdown-item";
import "vant/es/search/style/less";
import _Search from "vant/es/search";
import "vant/es/swipe/style/less";
import _Swipe from "vant/es/swipe";
import "vant/es/swipe-item/style/less";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/cell/style/less";
import _Cell from "vant/es/cell";
import "vant/es/cell-group/style/less";
import _CellGroup from "vant/es/cell-group";
import "vant/es/badge/style/less";
import _Badge from "vant/es/badge";
import "vant/es/lazyload/style/less";
import _Lazyload from "vant/es/lazyload";
import "vant/es/empty/style/less";
import _Empty from "vant/es/empty";
import "vant/es/uploader/style/less";
import _Uploader from "vant/es/uploader";
import "vant/es/popup/style/less";
import _Popup from "vant/es/popup";
import "vant/es/picker/style/less";
import _Picker from "vant/es/picker";
import "vant/es/button/style/less";
import _Button from "vant/es/button";
import "vant/es/field/style/less";
import _Field from "vant/es/field";
import "vant/es/form/style/less";
import _Form from "vant/es/form";
import "vant/es/icon/style/less";
import _Icon from "vant/es/icon";
import "vant/es/tabbar/style/less";
import _Tabbar from "vant/es/tabbar";
import "vant/es/tabbar-item/style/less";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/nav-bar/style/less";
import _NavBar from "vant/es/nav-bar";
import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";

/*
 * @Author: your name
 * @Date: 2021-07-26 09:08:31
 * @LastEditTime: 2021-07-29 09:36:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \op-webe:\ubq-file\ubq-h5\src\core\lazy_lib\components_use.js
 */
import Vue from 'vue'; // UI组件按需加载

// 公用布局组件
import Header from '@/base/Header';
import Back from '@/base/Back';
import Pagebottomtext from '@/components/Pagebottomtext'; // import Scroll from "@/base/Scroll"
// 公用动画组件

import lottie from 'vue-lottie';
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(_Toast);
Vue.use(_NavBar);
Vue.use(_Tabbar).use(_TabbarItem);
Vue.use(_Icon);
Vue.use(_Form);
Vue.use(_Field);
Vue.use(_Button);
Vue.use(_Picker);
Vue.use(_Popup);
Vue.use(_Uploader);
Vue.use(_Empty);
Vue.use(_Lazyload, {
  lazyComponent: true
});
Vue.use(_Badge);
Vue.use(_Cell).use(_CellGroup);
Vue.use(_Swipe).use(_SwipeItem);
Vue.use(_Search);
Vue.use(_DropdownMenu).use(_DropdownItem);
Vue.use(_Step).use(_Steps);
Vue.use(_Loading);
Vue.use(_ImagePreview);
Vue.use(_Dialog);
Vue.use(_List);
Vue.use(_PullRefresh);
Vue.use(_Checkbox).use(_CheckboxGroup);
Vue.use(_Radio).use(_RadioGroup);
Vue.use(_Image);
Vue.use(_Stepper);
Vue.use(_CountDown);
Vue.use(_PasswordInput).use(_NumberKeyboard);
Vue.use(_Overlay);
Vue.use(_Tab);
Vue.use(_Tabs);
Vue.use(_Slider);
Vue.use(_Tag);
Vue.use(_Progress);
Vue.use(_Cascader);
Vue.use(_Divider);
Vue.use(_Collapse);
Vue.use(_CollapseItem);
Vue.use(_Sticky);
Vue.use(_DatetimePicker);
Vue.use(_Switch);
Vue.use(_NoticeBar);
Vue.use(_Skeleton); // 添加骨架屏为全局使用

Vue.use(_PullRefresh);
Vue.use(VueClipboard);
Vue.use(_SwipeCell);
Vue.use(_Popover);
Vue.component('Header', Header);
Vue.component('Lottie', lottie);
Vue.component('Back', Back);
Vue.component('Pagebottomtext', Pagebottomtext); // Vue.component('Scroll',Scroll)

_Toast.setDefaultOptions({
  duration: 1500
});

Vue.prototype.$ImagePreview = _ImagePreview;
Vue.prototype.$Dialog = _Dialog;